export function toParams(
  path: string,
  params:
    | Exclude<ConstructorParameters<typeof URLSearchParams>[0], undefined>
    | SearchParamsBuilder,
) {
  const searchParams = new URLSearchParams(
    params instanceof SearchParamsBuilder ? params.searchParams : params,
  );
  return `${path}?${searchParams.toString()}`;
}

export function validateRedirectUrl(
  redirectUrl: string | null,
  defaultUrl: string,
): string {
  if (!redirectUrl) {
    return defaultUrl;
  }

  try {
    const url = new URL(redirectUrl);
    const allowedHosts = ['localhost', 'blurb.com', 'blurb.internal'];

    // Check if the hostname matches one of the allowed hosts or is a subdomain of them
    const isAllowed = allowedHosts.some(
      (host) => url.hostname === host || url.hostname.endsWith(`.${host}`),
    );

    if (isAllowed) {
      return redirectUrl;
    } else {
      console.warn(`Invalid redirect URL host: ${url.hostname}`);
      return defaultUrl;
    }
  } catch (error) {
    // If redirectUrl is a relative path, allow it
    if (redirectUrl.startsWith('/')) {
      return redirectUrl;
    } else {
      console.warn(`Invalid redirect URL: ${redirectUrl}`);
      return defaultUrl;
    }
  }
}

export class SearchParamsBuilder {
  readonly searchParams: URLSearchParams;

  constructor(searchParams?: URLSearchParams) {
    this.searchParams = new URLSearchParams(searchParams);
  }

  public filter(callback: (key: string, value: string) => boolean | void) {
    this.searchParams.forEach((value, key) => {
      const result = callback(key, value);
      if (!result) {
        this.searchParams.delete(key);
      }
    });

    return this;
  }

  public add(key: string, value: string) {
    if (!value) return this;

    if (this.searchParams.has(key)) {
      this.searchParams.delete(key);
    }

    this.searchParams.append(key, value);

    return this;
  }
}
